import script from "./Cancellation.component.vue?vue&type=script&setup=true&lang=js"
export * from "./Cancellation.component.vue?vue&type=script&setup=true&lang=js"

import "./Cancellation.component.vue?vue&type=style&index=0&id=47d5322e&lang=scss"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
